<template>
  <div class="maincont child" id="user_setting">
    <div class="ef--inner">
      <h2>お客さま設定</h2>
      <div class="form" method="post" action>
        <div id="user_setting_form">
          <ul>
            <span class="lt">パスワード</span>
            <li style="padding-left: 10px;">
              <input
                type="button"
                id="passChg"
                class="passChg"
                value="パスワード変更"
                @click="showModal = true"
              />
            </li>
          </ul>
          <div id="submit_area">
            <input
              type="button"
              id="cancel"
              class="cancel"
              value="戻る"
              @click="$router.go(-1)"
            />
          </div>
        </div>
      </div>
    </div>
    <password-dialog
      @close="showModal = false"
      v-if="showModal"
      :account="this.$store.state.childID"
    ></password-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import PasswordDialog from "../../components/PasswordDialog";

export default {
  name: "EsSetting",
  computed: {
    
  },
  components: {
    PasswordDialog

  },
  
  data: function() {
    return {
      showModal: false,
     
    };
  },
  
  methods: {
    
  },
  mounted: function() {

  }
};
</script>
<style scoped>

</style>
